import LoginComponent from "./Components/LoginComponent/LoginComponent";
import Content from "./Pages/Layout/Content/Content";
import "./App.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {
  const clientId = localStorage.getItem("clientId");
  return (
    <div className="App" style={{ overflowY: "hidden" }}>
      {/* {clientId > 0 || clientId !== null ? <Content /> : <LoginComponent />}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        bodyClassName="toastBody"
        theme="colored"
      /> */}
      <Content />
    </div>
  );
}

export default App;
